import electron from "./electronMirror";
import { NativeMenuItemProps } from "../../library/ContextMenu/ContextMenuProps";
import BasicRecord from "../utils/BasicRecord";
import MenuItem from "./MenuItem";

interface Params {
    items: NativeMenuItemProps[];
    onClose: () => void;
}

function createMenuTemplateAndAssignCallbacks(
    items: NativeMenuItemProps[],
    callbackMap: BasicRecord<() => void>,
    idPrefix = ""
): MenuItem[] {
    const menu: MenuItem[] = [];

    for (let i = 0; i < items.length; i++) {
        const { onClick, subMenu, ...props } = items[i];
        const itemId = `${idPrefix}-${i}`;

        callbackMap[itemId] = onClick!;

        const menuItem = new MenuItem({
            ...props,
            id: itemId
        });

        if (subMenu) {
            menuItem.submenu =
                createMenuTemplateAndAssignCallbacks(subMenu, callbackMap, idPrefix ? `${idPrefix}-${i}` : `${i}`);
        }
        menu.push(menuItem);
    }

    return menu;
}

export default function contextMenu({ items, onClose }: Params) {
    const callbackMap: BasicRecord<() => void> = {};
    const template = createMenuTemplateAndAssignCallbacks(items, callbackMap);

    electron!.actions.unregisterContextMenuItemClickedListener();
    electron!.actions.unregisterContextMenuClosedListeners();

    electron!.actions.sendContextMenuTemplate({
        template
    });

    electron!.actions.onContextMenuItemClicked((_: unknown, { id }: { id: string; }) => {
        callbackMap[id]?.();
    });

    electron!.actions.onContextMenuClosed(onClose);
}
